import React from "react";
import { Document, Text, Page, StyleSheet, Image, View, Font } from "@react-pdf/renderer";
import {Table, TR, TH, TD} from '@ag-media/react-pdf-table';
import attentionMark from "./attention.png";
// import goodMark from "./good.png";
// import badMark from "./bad.png";

const PDF = ({date, user, testNumber, tasks, score, answer1, answer2, answer3, answer4, answer5, answer6, answer7, answer8, answer9, answer10, answer11, answer12, answer13, answer14, answer15, answer16, answer17, answer18, answer19, answer20, answer21, answer22, answer23, answer24, answer25, answer26, answer27, answer28}) => {
const badMark = "data:image/png;base64,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";
const goodMark = "data:image/png;base64,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"
    Font.register({
        family: "IBM Plex Mono Medium",
        src:
          "https://fonts.cdnfonts.com/s/27347/IBMPlexMono-Medium.woff"
      });

    const styles = StyleSheet.create({
        body: {
            paddingTop: 35,
            paddingBottom: 65,
            paddingHorizontal: 35,
            fontFamily : "IBM Plex Mono Medium",
            fontSize: 14
        },
        subscript: {
            fontSize: 10, // уменьшенный размер шрифта
            verticalAlign: 'sub', // выравнивание по нижнему регистру
        }
    });

    function sortAnswerArrays(x, y){
        var pre = ['string' , 'number' , 'bool']
        if(typeof x!== typeof y )return pre.indexOf(typeof y) - pre.indexOf(typeof x);
    
        if(x === y)return 0;
        else return (x > y)?1:-1;
    }
    
    var currentUserName = user.localName ? user.localName : user.name;

    const preparedDate = date.toDate().getDate()+"."+(date.toDate().getMonth()+1)+"."+date.toDate().getFullYear();
    const currentTestNumberStr = testNumber.toString().slice(0, -1);
    const currentTestNumber = Number(currentTestNumberStr);

    var currentTask1 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 1);
    var currentTask2 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 2);
    var currentTask3 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 3);
    var currentTask4 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 4);
    var currentTask5 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 5);
    var currentTask6 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 6);
    var currentTask7 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 7);
    var currentTask8 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 8);
    var currentTask9 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 9);
    var currentTask10 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 10);
    var currentTask11 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 11);
    var currentTask12 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 12);
    var currentTask13 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 13);
    var currentTask14 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 14);
    var currentTask15 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 15);
    var currentTask16 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 16);
    var currentTask17 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 17);
    var currentTask18 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 18);
    var currentTask19 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 19);
    var currentTask20 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 20);
    var currentTask21 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 21);
    var currentTask22 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 22);
    var currentTask23 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 23);
    var currentTask24 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 24);
    var currentTask25 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 25);
    var currentTask26 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 26);
    var currentTask27 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 27);
    var currentTask28 = tasks.find((task) => task.testNumber === currentTestNumber && task.questionNumber === 28);
    
    var isRightTask1 = false;
    if(currentTask1 !== undefined && Array.isArray(answer1) && Array.isArray(currentTask1.rightAnswer)){
        if(answer1.sort(sortAnswerArrays).toString() === currentTask1.rightAnswer.sort(sortAnswerArrays).toString()){
            isRightTask1 = true;
        };
    }

    var isRightTask2 = false;
    if(currentTask2 !== undefined){
        if(answer2 === currentTask2.rightAnswer.join(", ")){
            isRightTask2 = true;
        };
    }

    var isRightTask3 = false;
    if(currentTask3 !== undefined && Array.isArray(answer3) && Array.isArray(currentTask3.rightAnswer)){
        if(answer3.sort(sortAnswerArrays).toString() === currentTask3.rightAnswer.sort(sortAnswerArrays).toString()){
            isRightTask3 = true;
        };
    }

    var isRightTask4 = false;
    if(currentTask4 !== undefined && Array.isArray(answer4) && Array.isArray(currentTask4.rightAnswer)){
        if(answer4.sort(sortAnswerArrays).toString() === currentTask4.rightAnswer.sort(sortAnswerArrays).toString()){
            isRightTask4 = true;
        };
    }

    var isRightTask5 = false;
    if(currentTask5 !== undefined){
        if(answer5 === currentTask5.rightAnswer.join(", ")){
            isRightTask5 = true;
        };
    }

    var isRightTask6 = false;
    if(currentTask6 !== undefined){
        if(answer6 === currentTask6.rightAnswer.join(", ")){
            isRightTask6 = true;
        };
    }

    var isRightTask7 = false;
    if(currentTask7 !== undefined){
        if(answer7 === currentTask7.rightAnswer.join(", ")){
            isRightTask7 = true;
        };
    }

    var isRightTask8 = false;
    if(currentTask8 !== undefined){
        if(answer8 === currentTask8.rightAnswer.join(", ")){
            isRightTask8 = true;
        };
    }

    var isRightTask9 = false;
    if(currentTask9 !== undefined){
        if(answer9 === currentTask9.rightAnswer.join(", ")){
            isRightTask9 = true;
        };
    }

    var isRightTask10 = false;
    if(currentTask10 !== undefined){
        if(answer10 === currentTask10.rightAnswer.join(", ")){
            isRightTask10 = true;
        };
    }

    var isRightTask11 = false;
    if(currentTask11 !== undefined && Array.isArray(answer11) && Array.isArray(currentTask11.rightAnswer)){
        if(answer11.sort(sortAnswerArrays).toString() === currentTask11.rightAnswer.sort(sortAnswerArrays).toString()){
            isRightTask11 = true;
        };
    }

    var isRightTask12 = false;
    if(currentTask12 !== undefined && Array.isArray(answer12) && Array.isArray(currentTask12.rightAnswer)){
        if(answer12.sort(sortAnswerArrays).toString() === currentTask12.rightAnswer.sort(sortAnswerArrays).toString()){
            isRightTask12 = true;
        };
    }

    var isRightTask13 = false;
    if(currentTask13 !== undefined && Array.isArray(answer13) && Array.isArray(currentTask13.rightAnswer)){
        if(answer13.sort(sortAnswerArrays).toString() === currentTask13.rightAnswer.sort(sortAnswerArrays).toString()){
            isRightTask13 = true;
        };
    }

    var isRightTask14 = false;
    if(currentTask14 !== undefined){
        if(answer14 === currentTask14.rightAnswer.join(", ")){
            isRightTask14 = true;
        };
    }

    var isRightTask15 = false;
    if(currentTask15 !== undefined){
        if(answer15 === currentTask15.rightAnswer.join(", ")){
            isRightTask15 = true;
        };
    }

    var isRightTask16 = false;
    if(currentTask16 !== undefined){
        if(answer16 === currentTask16.rightAnswer.join(", ")){
            isRightTask16 = true;
        };
    }

    // 12 задание
    var currentTask12FirstText = "";
    var currentTask12FirstImage = "";
    var currentTask12SecondText = "";
    var currentTask12SecondImage = "";
    var currentTask12ThirdText = "";
    var currentTask12ThirdImage = "";
    var currentTask12FourthText = "";
    var currentTask12FourthImage = "";
    var currentTask12FifthText = "";
    var currentTask12FifthImage = "";
    if(currentTask12 !== undefined){
        if(currentTask12.answer1 === ""){
            currentTask12FirstImage = currentTask12.imageFirstRef
        } else {
            currentTask12FirstText = currentTask12.answer1
        };
        if(currentTask12.answer2 === ""){
            currentTask12SecondImage = currentTask12.imageSecondRef
        } else {
            currentTask12SecondText = currentTask12.answer2
        };
        if(currentTask12.answer3 === ""){
            currentTask12ThirdImage = currentTask12.imageThirdRef
        } else {
            currentTask12ThirdText = currentTask12.answer3
        };
        if(currentTask12.answer4 === ""){
            currentTask12FourthImage = currentTask12.imageFourthRef
        } else {
            currentTask12FourthText = currentTask12.answer4
        };
        if(currentTask12.answer5 === ""){
            currentTask12FifthImage = currentTask12.imageFifthRef
        } else {
            currentTask12FifthText = currentTask12.answer5
        };
    };

    // 13 задание
    var currentTask13FirstText = "";
    var currentTask13FirstImage = "";
    var currentTask13SecondText = "";
    var currentTask13SecondImage = "";
    var currentTask13ThirdText = "";
    var currentTask13ThirdImage = "";
    var currentTask13FourthText = "";
    var currentTask13FourthImage = "";
    var currentTask13FifthText = "";
    var currentTask13FifthImage = "";
    if(currentTask13 !== undefined){
        if(currentTask13.answer1 === ""){
            currentTask13FirstImage = currentTask13.imageFirstRef
        } else {
            currentTask13FirstText = currentTask13.answer1
        };
        if(currentTask13.answer2 === ""){
            currentTask13SecondImage = currentTask13.imageSecondRef
        } else {
            currentTask13SecondText = currentTask13.answer2
        };
        if(currentTask13.answer3 === ""){
            currentTask13ThirdImage = currentTask13.imageThirdRef
        } else {
            currentTask13ThirdText = currentTask13.answer3
        };
        if(currentTask13.answer4 === ""){
            currentTask13FourthImage = currentTask13.imageFourthRef
        } else {
            currentTask13FourthText = currentTask13.answer4
        };
        if(currentTask13.answer5 === ""){
            currentTask13FifthImage = currentTask13.imageFifthRef
        } else {
            currentTask13FifthText = currentTask13.answer5
        };
    };

    // 14 задание
    var currentTask14SubsFirstText = "";
    var currentTask14SubsFirstImage = "";
    var currentTask14SubsSecondText = "";
    var currentTask14SubsSecondImage = "";
    var currentTask14SubsThirdText = "";
    var currentTask14SubsThirdImage = "";
    var currentTask14SubsFourthText = "";
    var currentTask14SubsFourthImage = "";
    if(currentTask14 !== undefined){
        if(currentTask14.substance1 === ""){
            currentTask14SubsFirstImage = currentTask14.imageFirstRefSubstance
        } else {
            currentTask14SubsFirstText = currentTask14.substance1
        };
        if(currentTask14.substance2 === ""){
            currentTask14SubsSecondImage = currentTask14.imageSecondRefSubstance
        } else {
            currentTask14SubsSecondText = currentTask14.substance2
        };
        if(currentTask14.substance3 === ""){
            currentTask14SubsThirdImage = currentTask14.imageThirdRefSubstance
        } else {
            currentTask14SubsThirdText = currentTask14.substance3
        };
        if(currentTask14.substance4 === ""){
            currentTask14SubsFourthImage = currentTask14.imageFourthRefSubstance
        } else {
            currentTask14SubsFourthText = currentTask14.substance4
        };
    };
    var currentTask14ReagFirstText = "";
    var currentTask14ReagFirstImage = "";
    var currentTask14ReagSecondText = "";
    var currentTask14ReagSecondImage = "";
    var currentTask14ReagThirdText = "";
    var currentTask14ReagThirdImage = "";
    var currentTask14ReagFourthText = "";
    var currentTask14ReagFourthImage = "";
    var currentTask14ReagFifthText = "";
    var currentTask14ReagFifthImage = "";
    var currentTask14ReagSixText = "";
    var currentTask14ReagSixImage = "";
    if(currentTask14 !== undefined){
        if(currentTask14.reagent1 === ""){
            currentTask14ReagFirstImage = currentTask14.imageFirstRefReagent
        } else {
            currentTask14ReagFirstText = currentTask14.reagent1
        };
        if(currentTask14.reagent2 === ""){
            currentTask14ReagSecondImage = currentTask14.imageSecondRefReagent
        } else {
            currentTask14ReagSecondText = currentTask14.reagent2
        };
        if(currentTask14.reagent3 === ""){
            currentTask14ReagThirdImage = currentTask14.imageThirdRefReagent
        } else {
            currentTask14ReagThirdText = currentTask14.reagent3
        };
        if(currentTask14.reagent4 === ""){
            currentTask14ReagFourthImage = currentTask14.imageFourthRefReagent
        } else {
            currentTask14ReagFourthText = currentTask14.reagent4
        };
        if(currentTask14.reagent5 === ""){
            currentTask14ReagFifthImage = currentTask14.imageFifthRefReagent
        } else {
            currentTask14ReagFifthText = currentTask14.reagent5
        };
        if(currentTask14.reagent6 === ""){
            currentTask14ReagSixImage = currentTask14.imageSixRefReagent
        } else {
            currentTask14ReagSixText = currentTask14.reagent6
        };
    };

    // 15 задание
    var currentTask15SubsFirstText = "";
    var currentTask15SubsFirstImage = "";
    var currentTask15SubsSecondText = "";
    var currentTask15SubsSecondImage = "";
    var currentTask15SubsThirdText = "";
    var currentTask15SubsThirdImage = "";
    var currentTask15SubsFourthText = "";
    var currentTask15SubsFourthImage = "";
    if(currentTask15 !== undefined){
        if(currentTask15.substance1 === ""){
            currentTask15SubsFirstImage = currentTask15.imageFirstRefSubstance
        } else {
            currentTask15SubsFirstText = currentTask15.substance1
        };
        if(currentTask15.substance2 === ""){
            currentTask15SubsSecondImage = currentTask15.imageSecondRefSubstance
        } else {
            currentTask15SubsSecondText = currentTask15.substance2
        };
        if(currentTask15.substance3 === ""){
            currentTask15SubsThirdImage = currentTask15.imageThirdRefSubstance
        } else {
            currentTask15SubsThirdText = currentTask15.substance3
        };
        if(currentTask15.substance4 === ""){
            currentTask15SubsFourthImage = currentTask15.imageFourthRefSubstance
        } else {
            currentTask15SubsFourthText = currentTask15.substance4
        };
    };
    var currentTask15ReagFirstText = "";
    var currentTask15ReagFirstImage = "";
    var currentTask15ReagSecondText = "";
    var currentTask15ReagSecondImage = "";
    var currentTask15ReagThirdText = "";
    var currentTask15ReagThirdImage = "";
    var currentTask15ReagFourthText = "";
    var currentTask15ReagFourthImage = "";
    var currentTask15ReagFifthText = "";
    var currentTask15ReagFifthImage = "";
    var currentTask15ReagSixText = "";
    var currentTask15ReagSixImage = "";
    if(currentTask15 !== undefined){
        if(currentTask15.reagent1 === ""){
            currentTask15ReagFirstImage = currentTask15.imageFirstRefReagent
        } else {
            currentTask15ReagFirstText = currentTask15.reagent1
        };
        if(currentTask15.reagent2 === ""){
            currentTask15ReagSecondImage = currentTask15.imageSecondRefReagent
        } else {
            currentTask15ReagSecondText = currentTask15.reagent2
        };
        if(currentTask15.reagent3 === ""){
            currentTask15ReagThirdImage = currentTask15.imageThirdRefReagent
        } else {
            currentTask15ReagThirdText = currentTask15.reagent3
        };
        if(currentTask15.reagent4 === ""){
            currentTask15ReagFourthImage = currentTask15.imageFourthRefReagent
        } else {
            currentTask15ReagFourthText = currentTask15.reagent4
        };
        if(currentTask15.reagent5 === ""){
            currentTask15ReagFifthImage = currentTask15.imageFifthRefReagent
        } else {
            currentTask15ReagFifthText = currentTask15.reagent5
        };
        if(currentTask15.reagent6 === ""){
            currentTask15ReagSixImage = currentTask15.imageSixRefReagent
        } else {
            currentTask15ReagSixText = currentTask15.reagent6
        };
    };

    // 16 задание
    var currentTask16Image = false;
    if(currentTask16 !== undefined){
        if(currentTask16.imageRef === ""){
            currentTask16Image = false;
        } else {
            currentTask16Image = true;
        };
    }

    var isRightTask17 = false;
    if(currentTask17 !== undefined && Array.isArray(answer17) && Array.isArray(currentTask17.rightAnswer)){
        if(answer17.sort(sortAnswerArrays).toString() === currentTask17.rightAnswer.sort(sortAnswerArrays).toString()){
            isRightTask17 = true;
        };
    }

    var isRightTask18 = false;
    if(currentTask18 !== undefined && Array.isArray(answer18) && Array.isArray(currentTask18.rightAnswer)){
        if(answer18.sort(sortAnswerArrays).toString() === currentTask18.rightAnswer.sort(sortAnswerArrays).toString()){
            isRightTask18 = true;
        };
    }

    var isRightTask19 = false;
    if(currentTask19 !== undefined){
        if(answer19 === currentTask19.rightAnswer.join(", ")){
            isRightTask19 = true;
        };
    }

    var isRightTask20 = false;
    if(currentTask20 !== undefined){
        if(answer20 === currentTask20.rightAnswer.join(", ")){
            isRightTask20 = true;
        };
    }

    var isRightTask21 = false;
    if(currentTask21 !== undefined){
        if(answer21 === currentTask21.rightAnswer.join(", ")){
            isRightTask21 = true;
        };
    }

    var isRightTask22 = false;
    if(currentTask22 !== undefined){
        if(answer22 === currentTask22.rightAnswer.join(", ")){
            isRightTask22 = true;
        };
    }

    var currentTask23Image = false;
    if(currentTask23 !== undefined){
        if(currentTask23.imageRef === ""){
            currentTask23Image = false;
        } else {
            currentTask23Image = true;
        };
    }

    var isRightTask23 = false;
    if(currentTask23 !== undefined){
        if(answer23 === currentTask23.rightAnswer.join(", ")){
            isRightTask23 = true;
        };
    }

    var isRightTask24 = false;
    if(currentTask24 !== undefined){
        if(answer24 === currentTask24.rightAnswer.join(", ")){
            isRightTask24 = true;
        };
    }

    var isRightTask25 = false;
    if(currentTask25 !== undefined){
        if(answer25 === currentTask25.rightAnswer.join(", ")){
            isRightTask25 = true;
        };
    }

    var isRightTask26 = false;
    if(currentTask26 !== undefined){
        if(answer26 === currentTask26.rightAnswer){
            isRightTask26 = true;
        };
    }

    var isRightTask27 = false;
    if(currentTask27 !== undefined){
        if(answer27 === currentTask27.rightAnswer){
            isRightTask27 = true;
        };
    }

    var isRightTask28 = false;
    if(currentTask28 !== undefined){
        if(answer28 === currentTask28.rightAnswer){
            isRightTask28 = true;
        };
    }

    function containsNumber(str) {
        var newArrayForString = [];
        if(str !== undefined){
            for (let i = 0; i < str.length; i++) {
                if(/\d/.test(str[i]) === true) {
                    if(str[i-1] === '@') {
                        newArrayForString.push(str[i]);
                    } else if(str[i] === '0') {
                        newArrayForString.push(str[i]);
                    } else {
                        newArrayForString.push(str[i]);
                    }
                } else if(str[i] === '@') {
                    newArrayForString.push("");
                } else if(str[i] === '+'){
                    if(str[i-1] === '@') {
                        newArrayForString.push(str[i]);
                    } else {
                        newArrayForString.push(str[i]);
                    };
                } else if(str[i] === '-'){
                    if(str[i-1] === '@') {
                        newArrayForString.push(str[i]);
                    } else {
                        newArrayForString.push(str[i]);
                    };
                } else {
                    newArrayForString.push(str[i]);
                };
            };
            return newArrayForString.join('');
        } else {
            return str;
        };
    };
    console.log(answer1)

    return (
        <Document>
            <Page size="A4" style={styles.body}>
                <View style={{marginBottom: 10}}>
                    <Text>
                        Студент: {currentUserName}
                    </Text>
                    <Text>
                        Дата: {preparedDate}
                    </Text>
                    <Text>
                        Вариант: {currentTestNumber}
                    </Text>
                    <Text>
                        Кол-во набранных баллов: {score} / 36
                    </Text>
                </View>
                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 1 
                        {/* {isRightTask1 === true ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask1 ? currentTask1.question : "no data"}
                    </Text>
                    <Text>
                        1) {currentTask1 ? currentTask1.answer1 : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask1 ? currentTask1.answer2 : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask1 ? currentTask1.answer3 : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask1 ? currentTask1.answer4 : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask1 ? currentTask1.answer5 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer1}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask1 ? currentTask1.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 2 
                        {/* {isRightTask2 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask2 ? currentTask2.question : "no data"}
                    </Text>
                    <Text>
                        1) {currentTask2 ? currentTask2.answer1 : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask2 ? currentTask2.answer2 : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask2 ? currentTask2.answer3 : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask2 ? currentTask2.answer4 : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask2 ? currentTask2.answer5 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer2}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask2 ? currentTask2.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 3 
                        {/* {isRightTask3 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask3 ? currentTask3.question : "no data"}
                    </Text>
                    <Text>
                        1) {currentTask3 ? currentTask3.answer1 : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask3 ? currentTask3.answer2 : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask3 ? currentTask3.answer3 : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask3 ? currentTask3.answer4 : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask3 ? currentTask3.answer5 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer3}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask3 ? currentTask3.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 4 
                        {/* {isRightTask4 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask4 ? currentTask4.question : "no data"}
                    </Text>
                    <Text>
                        1) {currentTask4 ? currentTask4.answer1 : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask4 ? currentTask4.answer2 : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask4 ? currentTask4.answer3 : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask4 ? currentTask4.answer4 : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask4 ? currentTask4.answer5 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer4}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask4 ? currentTask4.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 5 
                        {/* {isRightTask5 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask5 ? currentTask5.question : "no data"}
                    </Text>
                    <Table>
                        <TH>
                            <TD>1) {currentTask5 ? containsNumber(currentTask5.answer1) : "no data"}</TD>
                            <TD>2) {currentTask5 ? containsNumber(currentTask5.answer2) : "no data"}</TD>
                            <TD>3) {currentTask5 ? containsNumber(currentTask5.answer3) : "no data"}</TD>
                        </TH>
                        <TR>
                            <TD>4) {currentTask5 ? containsNumber(currentTask5.answer4) : "no data"}</TD>
                            <TD>5) {currentTask5 ? containsNumber(currentTask5.answer5) : "no data"}</TD>
                            <TD>6) {currentTask5 ? containsNumber(currentTask5.answer6) : "no data"}</TD>
                        </TR>
                        <TR>
                            <TD>7) {currentTask5 ? containsNumber(currentTask5.answer7) : "no data"}</TD>
                            <TD>8) {currentTask5 ? containsNumber(currentTask5.answer8) : "no data"}</TD>
                            <TD>9) {currentTask5 ? containsNumber(currentTask5.answer9) : "no data"}</TD>
                        </TR>
                    </Table>
                    <Text>
                        Ответ студента: {answer5}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask5 ? currentTask5.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 6 
                        {/* {isRightTask6 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask6 ? currentTask6.question : "no data"}
                    </Text>
                    <Text>
                        1) {currentTask6 ? containsNumber(currentTask6.answer1) : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask6 ? containsNumber(currentTask6.answer2) : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask6 ? containsNumber(currentTask6.answer3) : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask6 ? containsNumber(currentTask6.answer4) : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask6 ? containsNumber(currentTask6.answer5) : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer6}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask6 ? currentTask6.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 7 
                        {/* {isRightTask7 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask7 ? currentTask7.question : "no data"}
                    </Text>
                    <Text>
                        Вещества:
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask7 ? containsNumber(currentTask7.substance1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask7 ? containsNumber(currentTask7.substance2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask7 ? containsNumber(currentTask7.substance3) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Г) {currentTask7 ? containsNumber(currentTask7.substance4) : "no data"}
                    </Text>
                    <Text>
                        Реагенты:
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask7 ? containsNumber(currentTask7.reagent1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask7 ? containsNumber(currentTask7.reagent2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask7 ? containsNumber(currentTask7.reagent3) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        4) {currentTask7 ? containsNumber(currentTask7.reagent4) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        5) {currentTask7 ? containsNumber(currentTask7.reagent5) : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer7}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask7 ? currentTask7.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 8 
                        {/* {isRightTask8 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask8 ? currentTask8.question : "no data"}
                    </Text>
                    <Text>
                        Вещества:
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask8 ? containsNumber(currentTask8.substance1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask8 ? containsNumber(currentTask8.substance2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask8 ? containsNumber(currentTask8.substance3) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Г) {currentTask8 ? containsNumber(currentTask8.substance4) : "no data"}
                    </Text>
                    <Text>
                        Реагенты:
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask8 ? containsNumber(currentTask8.reagent1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask8 ? containsNumber(currentTask8.reagent2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask8 ? containsNumber(currentTask8.reagent3) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        4) {currentTask8 ? containsNumber(currentTask8.reagent4) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        5) {currentTask8 ? containsNumber(currentTask8.reagent5) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        6) {currentTask8 ? containsNumber(currentTask8.reagent6) : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer8}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask8 ? currentTask8.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>
                
                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 9 
                        {/* {isRightTask9 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask9 ? currentTask9.question : "no data"}
                    </Text>
                    {/* <Image style={{maxWidth: 200, maxHeight: 50}} src={currentTask9 ? currentTask9.imageRef : null} /> */}
                    <Text>
                        1) {currentTask9 ? containsNumber(currentTask9.answer1) : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask9 ? containsNumber(currentTask9.answer2) : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask9 ? containsNumber(currentTask9.answer3) : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask9 ? containsNumber(currentTask9.answer4) : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask9 ? containsNumber(currentTask9.answer5) : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer9}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask9 ? currentTask9.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 10 
                        {/* {isRightTask10 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask10 ? currentTask10.question : "no data"}
                    </Text>
                    <Text>
                        Вещества:
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask10 ? containsNumber(currentTask10.substance1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask10 ? containsNumber(currentTask10.substance2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask10 ? containsNumber(currentTask10.substance3) : "no data"}
                    </Text>
                    <Text>
                        Реагенты:
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask10 ? currentTask10.reagent1 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask10 ? currentTask10.reagent2 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask10 ? currentTask10.reagent3 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        4) {currentTask10 ? currentTask10.reagent4 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer10}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask10 ? currentTask10.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 11 
                        {/* {isRightTask11 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask11 ? currentTask11.question : "no data"}
                    </Text>
                    <Text>
                        1) {currentTask11 ? currentTask11.answer1 : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask11 ? currentTask11.answer2 : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask11 ? currentTask11.answer3 : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask11 ? currentTask11.answer4 : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask11 ? currentTask11.answer5 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer11}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask11 ? currentTask11.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 12 
                        {/* {isRightTask12 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask12 ? currentTask12.question : "no data"}
                    </Text>
                    {/* <Image style={{maxWidth: 200, maxHeight: 50}} src={currentTask12 ? currentTask12.questionImageRef : null} /> */}
                    <Text>
                        1) {currentTask12FirstText === "" ? <Image src={currentTask12FirstImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask12FirstText)}
                    </Text>
                    <Text>
                        2) {currentTask12SecondText === "" ? <Image src={currentTask12SecondImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask12SecondText)}
                    </Text>
                    <Text>
                        3) {currentTask12ThirdText === "" ? <Image src={currentTask12ThirdImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask12ThirdText)}
                    </Text>
                    <Text>
                        4) {currentTask12FourthText === "" ? <Image src={currentTask12FourthImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask12FourthText)}
                    </Text>
                    <Text>
                        5) {currentTask12FifthText === "" ? <Image src={currentTask12FifthImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask12FifthText)}
                    </Text>
                    <Text>
                        Ответ студента: {answer12}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask12 ? currentTask12.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 13 
                        {/* {isRightTask13 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask13 ? currentTask13.question : "no data"}
                    </Text>
                    <Text>
                        1) {currentTask13FirstText === "" ? <Image src={currentTask13FirstImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask13FirstText)}
                    </Text>
                    <Text>
                        2) {currentTask13SecondText === "" ? <Image src={currentTask13SecondImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask13SecondText)}
                    </Text>
                    <Text>
                        3) {currentTask13ThirdText === "" ? <Image src={currentTask13ThirdImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask13ThirdText)}
                    </Text>
                    <Text>
                        4) {currentTask13FourthText === "" ? <Image src={currentTask13FourthImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask13FourthText)}
                    </Text>
                    <Text>
                        5) {currentTask13FifthText === "" ? <Image src={currentTask13FifthImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask13FifthText)}
                    </Text>
                    <Text>
                        Ответ студента: {answer13}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask13 ? currentTask13.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 14 
                        {/* {isRightTask14 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask14 ? currentTask14.question : "no data"}
                    </Text>
                    <Text>
                        {currentTask14 ? currentTask14.nameOfSubstance : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask14SubsFirstText === "" ? <Image src={currentTask14SubsFirstImage} style={{width: "200px", height: "50px"}} /> : currentTask14SubsFirstText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask14SubsSecondText === "" ? <Image src={currentTask14SubsSecondImage} style={{width: "200px", height: "50px"}} /> : currentTask14SubsSecondText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask14SubsThirdText === "" ? <Image src={currentTask14SubsThirdImage} style={{width: "200px", height: "50px"}} /> : currentTask14SubsThirdText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Г) {currentTask14SubsFourthText === "" ? <Image src={currentTask14SubsFourthImage} style={{width: "200px", height: "50px"}} /> : currentTask14SubsFourthText}
                    </Text>
                    <Text>
                        {currentTask14 ? currentTask14.nameOfReagent : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask14ReagFirstText === "" ? <Image src={currentTask14ReagFirstImage} style={{width: "200px", height: "50px"}} /> : currentTask14ReagFirstText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask14ReagSecondText === "" ? <Image src={currentTask14ReagSecondImage} style={{width: "200px", height: "50px"}} /> : currentTask14ReagSecondText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask14ReagThirdText === "" ? <Image src={currentTask14ReagThirdImage} style={{width: "200px", height: "50px"}} /> : currentTask14ReagThirdText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        4) {currentTask14ReagFourthText === "" ? <Image src={currentTask14ReagFourthImage} style={{width: "200px", height: "50px"}} /> : currentTask14ReagFourthText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        5) {currentTask14ReagFifthText === "" ? <Image src={currentTask14ReagFifthImage} style={{width: "200px", height: "50px"}} /> : currentTask14ReagFifthText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        6) {currentTask14ReagSixText === "" ? <Image src={currentTask14ReagSixImage} style={{width: "200px", height: "50px"}} /> : currentTask14ReagSixText}
                    </Text>
                    <Text>
                        Ответ студента: {answer14}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask14 ? currentTask14.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 15 
                        {/* {isRightTask15 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask15 ? currentTask15.question : "no data"}
                    </Text>
                    <Text>
                        {currentTask15 ? currentTask15.nameOfSubstance : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask15SubsFirstText === "" ? <Image src={currentTask15SubsFirstImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask15SubsFirstText)}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask15SubsSecondText === "" ? <Image src={currentTask15SubsSecondImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask15SubsSecondText)}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask15SubsThirdText === "" ? <Image src={currentTask15SubsThirdImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask15SubsThirdText)}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Г) {currentTask15SubsFourthText === "" ? <Image src={currentTask15SubsFourthImage} style={{width: "200px", height: "50px"}} /> : containsNumber(currentTask15SubsFourthText)}
                    </Text>
                    <Text>
                        {currentTask15 ? currentTask15.nameOfReagent : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask15ReagFirstText === "" ? <Image src={currentTask15ReagFirstImage} style={{width: "200px", height: "50px"}} /> : currentTask15ReagFirstText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask15ReagSecondText === "" ? <Image src={currentTask15ReagSecondImage} style={{width: "200px", height: "50px"}} /> : currentTask15ReagSecondText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask15ReagThirdText === "" ? <Image src={currentTask15ReagThirdImage} style={{width: "200px", height: "50px"}} /> : currentTask15ReagThirdText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        4) {currentTask15ReagFourthText === "" ? <Image src={currentTask15ReagFourthImage} style={{width: "200px", height: "50px"}} /> : currentTask15ReagFourthText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        5) {currentTask15ReagFifthText === "" ? <Image src={currentTask15ReagFifthImage} style={{width: "200px", height: "50px"}} /> : currentTask15ReagFifthText}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        6) {currentTask15ReagSixImage === "" ? currentTask15ReagSixText : <Image src={currentTask15ReagSixImage} style={{width: "200px", height: "50px"}} />}
                    </Text>
                    <Text>
                        Ответ студента: {answer15}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask15 ? currentTask15.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 16 
                        {/* {isRightTask16 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask16 ? currentTask16.question : "no data"}
                    </Text>
                    {/* {currentTask16Image ? <Image style={{maxWidth: 200, maxHeight: 50}} src={currentTask16 ? currentTask16.imageRef : null} /> : ""} */}
                    <Text>
                        1) {currentTask16 ? containsNumber(currentTask16.answer1) : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask16 ? containsNumber(currentTask16.answer2) : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask16 ? containsNumber(currentTask16.answer3) : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask16 ? containsNumber(currentTask16.answer4) : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask16 ? containsNumber(currentTask16.answer5) : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer16}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask16 ? currentTask16.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 17 
                        {/* {isRightTask17 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask17 ? currentTask17.question : "no data"}
                    </Text>
                    <Text>
                        1) {currentTask17 ? containsNumber(currentTask17.answer1) : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask17 ? containsNumber(currentTask17.answer2) : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask17 ? containsNumber(currentTask17.answer3) : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask17 ? containsNumber(currentTask17.answer4) : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask17 ? containsNumber(currentTask17.answer5) : "no data"}
                    </Text>
                    <Text>
                        6) {currentTask17 ? containsNumber(currentTask17.answer6) : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer17}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask17 ? currentTask17.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 18 
                        {/* {isRightTask18 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask18 ? currentTask18.question : "no data"}
                    </Text>
                    <Text>
                        1) {currentTask18 ? currentTask18.answer1 : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask18 ? currentTask18.answer2 : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask18 ? currentTask18.answer3 : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask18 ? currentTask18.answer4 : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask18 ? currentTask18.answer5 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer18}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask18 ? currentTask18.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 19 
                        {/* {isRightTask19 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask19 ? currentTask19.question : "no data"}
                    </Text>
                    <Text>
                        {currentTask19 ? currentTask19.nameOfSubstance : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask19 ? containsNumber(currentTask19.substance1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask19 ? containsNumber(currentTask19.substance2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask19 ? containsNumber(currentTask19.substance3) : "no data"}
                    </Text>
                    <Text>
                        {currentTask19 ? currentTask19.nameOfReagent : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask19 ? currentTask19.reagent1 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask19 ? currentTask19.reagent2 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask19 ? currentTask19.reagent3 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        4) {currentTask19 ? currentTask19.reagent4 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer19}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask19 ? currentTask19.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 20 
                        {/* {isRightTask20 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask20 ? currentTask20.question : "no data"}
                    </Text>
                    <Text>
                        {currentTask20 ? currentTask20.nameOfSubstance : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask20 ? containsNumber(currentTask20.substance1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask20 ? containsNumber(currentTask20.substance2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask20 ? containsNumber(currentTask20.substance3) : "no data"}
                    </Text>
                    <Text>
                        {currentTask20 ? currentTask20.nameOfReagent : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask20 ? containsNumber(currentTask20.reagent1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask20 ? containsNumber(currentTask20.reagent2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask20 ? containsNumber(currentTask20.reagent3) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        4) {currentTask20 ? containsNumber(currentTask20.reagent4) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        5) {currentTask20 ? currentTask20.reagent5 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer20}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask20 ? currentTask20.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 21 
                        {/* {isRightTask21 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask21 ? currentTask21.question : "no data"}
                    </Text>
                    {/* <Image style={{maxWidth: 200, maxHeight: 50}} src={currentTask21 ? currentTask21.imageRef : null} /> */}
                    <Text>
                        1) {currentTask21 ? currentTask21.answer1 : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask21 ? currentTask21.answer2 : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask21 ? currentTask21.answer3 : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask21 ? currentTask21.answer4 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer21}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask21 ? currentTask21.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 22 
                        {/* {isRightTask22 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask22 ? containsNumber(currentTask22.question) : "no data"}
                    </Text>
                    <Text>
                        {currentTask22 ? currentTask22.nameOfSubstance : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask22 ? containsNumber(currentTask22.substance1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask22 ? containsNumber(currentTask22.substance2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask22 ? containsNumber(currentTask22.substance3) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Г) {currentTask22 ? containsNumber(currentTask22.substance4) : "no data"}
                    </Text>
                    <Text>
                        {currentTask22 ? currentTask22.nameOfReagent : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask22 ? containsNumber(currentTask22.reagent1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask22 ? containsNumber(currentTask22.reagent2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask22 ? containsNumber(currentTask22.reagent3) : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer22}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask22 ? currentTask22.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 23 
                        {/* {isRightTask23 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask23 ? currentTask23.question : "no data"}
                    </Text>
                    {/* {currentTask23Image ? <Image style={{maxWidth: 200, maxHeight: 50}} src={currentTask23 ? currentTask23.imageRef : null} /> : ""} */}
                    <Text>
                        1) {currentTask23 ? currentTask23.answer1 : "no data"}
                    </Text>
                    <Text>
                        2) {currentTask23 ? currentTask23.answer2 : "no data"}
                    </Text>
                    <Text>
                        3) {currentTask23 ? currentTask23.answer3 : "no data"}
                    </Text>
                    <Text>
                        4) {currentTask23 ? currentTask23.answer4 : "no data"}
                    </Text>
                    <Text>
                        5) {currentTask23 ? currentTask23.answer5 : "no data"}
                    </Text>
                    <Text>
                        6) {currentTask23 ? currentTask23.answer6 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer23}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask23 ? currentTask23.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 24 
                        {/* {isRightTask24 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask24 ? currentTask24.question : "no data"}
                    </Text>
                    <Text>
                        {currentTask24 ? currentTask24.nameOfSubstance : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask24 ? containsNumber(currentTask24.substance1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask24 ? containsNumber(currentTask24.substance2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask24 ? containsNumber(currentTask24.substance3) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Г) {currentTask24 ? containsNumber(currentTask24.substance4) : "no data"}
                    </Text>
                    <Text>
                        {currentTask24 ? currentTask24.nameOfReagent : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask24 ? containsNumber(currentTask24.reagent1) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask24 ? containsNumber(currentTask24.reagent2) : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask24 ? containsNumber(currentTask24.reagent3) : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer24}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask24 ? currentTask24.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 25 
                        {/* {isRightTask25 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask25 ? currentTask25.question : "no data"}
                    </Text>
                    <Text>
                        {currentTask25 ? currentTask25.nameOfSubstance : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        А) {currentTask25 ? currentTask25.substance1 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        Б) {currentTask25 ? currentTask25.substance2 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        В) {currentTask25 ? currentTask25.substance3 : "no data"}
                    </Text>
                    <Text>
                        {currentTask25 ? currentTask25.nameOfReagent : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        1) {currentTask25 ? currentTask25.reagent1 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        2) {currentTask25 ? currentTask25.reagent2 : "no data"}
                    </Text>
                    <Text style={{marginLeft: 10}}>
                        3) {currentTask25 ? currentTask25.reagent3 : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer25}
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask25 ? currentTask25.rightAnswer.join(", ") : "no data"}
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 26 
                        {/* {isRightTask26 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask26 ? currentTask26.question : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer26} ({currentTask26 ? currentTask26.measuring : "no data"})
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask26 ? currentTask26.rightAnswer : "no data"} ({currentTask26 ? currentTask26.measuring : "no data"})
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 27 
                        {/* {isRightTask27 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask27 ? containsNumber(currentTask27.question) : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer27} ({currentTask27 ? currentTask27.measuring : "no data"})
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask27 ? currentTask27.rightAnswer : "no data"} ({currentTask27 ? currentTask27.measuring : "no data"})
                    </Text>
                </View>

                <View style={{marginLeft: 10, marginBottom: 10}}>
                    <Text style={{marginLeft: -10}}>
                        Задание 28 
                        {/* {isRightTask28 ? <Image src={goodMark} style={{width: "30px", height: "30px"}} /> : <Image src={badMark} style={{width: "30px", height: "30px"}} />} */}
                    </Text>
                    <Text>
                        {currentTask28 ? currentTask28.question : "no data"}
                    </Text>
                    <Text>
                        Ответ студента: {answer28} ({currentTask28 ? currentTask28.measuring : "no data"})
                    </Text>
                    <Text>
                        Правильный ответ: {currentTask28 ? currentTask28.rightAnswer : "no data"} ({currentTask28 ? currentTask28.measuring : "no data"})
                    </Text>
                </View>
            </Page>
        </Document>
    )
}

export default PDF;